export const countMaintenancesService = (fetch) => async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.startDate) params.append("startDate", filters.startDate);
    if (filters.endDate) params.append("endDate", filters.endDate);
    const query = params.toString();

    const response = await fetch({
      url: `/api/v1/mantenimiento/contar-mantenimientos${query ? `?${query}` : ""}`,
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
